import React from "react";
import l10n from "../../lib/l10n";
import Button from "@mui/material/Button";
import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";
import { useAppDialog } from "../../store/app-dialog";
import { CheckCircleOutline } from "@mui/icons-material";
import { Box, Stack, TextField, TextareaAutosize, Tooltip } from "@mui/material";

export const orderDialogProxy = (resolve, reject) => {
  // if (l10n.ui_order_notes_display === 'no') {
  //   return resolve({ wppr_order_email: null, order_comments: null, terms: null });
  // }
  return <DialogCheckoutOrder
    ok={resolve}
    cancel={reject}
  />
};

const DialogCheckoutOrder = ({ ok, cancel }) => {
  const [userEmail, setUserEmail] = React.useState(""); // eslint-disable-line no-unused-vars
  const [orderComments, setOrderComments] = React.useState("");
  const [termsChecked, setTerms] = React.useState(false);
  const {closeDialog} = useAppDialog();

  const onUserNotesChanged = (e) => {
    setOrderComments(e.target.value);
  };

  const onUserTermsChanged = (e) => {
    setTerms(e.target.checked);
  };

  const onClickRequestQuote = () => {
    ok({
      wppr_order_email: userEmail,
      order_comments: orderComments,
      terms: termsChecked 
    });
    // close dialog will automatically reject the promise (@see invokeDialog)
    closeDialog();
  };

  const getIsSubmitDisabled = () => {
    const termsEnabled = l10n.ui_terms_checkbox_enabled === 'yes';
    const notesDisplayed = l10n.ui_order_notes_display === 'yes';
    const notesRequired = l10n.ui_order_notes_required === 'yes';

    if (termsEnabled) {
      if (notesDisplayed && notesRequired) {
        return !termsChecked || orderComments === "";
      }
      return !termsChecked;
    }

    if (notesDisplayed && notesRequired) {
      return orderComments === "";
    }

    return false;
  };

  const tooltipTitle = (l10n.ui_terms_checkbox_enabled === 'yes' && !termsChecked) && (
    "Accetta i termini e le condizioni prima di procedere."
  );

  return (
    <Stack p={2}>
      <TextareaAutosize
        placeholder={l10n.ui_label_order_quote_notes}
        value={orderComments}
        onChange={onUserNotesChanged}
        minRows={4}
      />
      {/* <Box mb={2} mt={1}>
        <TextField 
          name="email"
          type="email"
          variant="standard"
          label="Email (opzionale)" 
          onChange={(event) => {
            console.log(event.target.value);
          }} 
        />
      </Box> */}
      {l10n.ui_terms_checkbox_enabled === 'yes' && (
        <FormControlLabel
          label={l10n.ui_label_order_quote_terms}
          control={<Checkbox checked={termsChecked} onChange={onUserTermsChanged} />}
          sx={{
            "& .MuiFormControlLabel-label": {
              fontSize: '0.8em'
            }
          }}
        />
      )}
      <Tooltip title={tooltipTitle} placement="bottom">
        <span>
          <Button
            variant="contained"
            color="success"
            fullWidth
            endIcon={<CheckCircleOutline />}
            disabled={getIsSubmitDisabled()}
            onClick={onClickRequestQuote}
          >
            Conferma
          </Button>
        </span>
      </Tooltip>
    </Stack>
  );
};

export default DialogCheckoutOrder;